import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import { useIntl } from 'sb-react-intl'
import { useConnect } from 'sb-redux-hook'

import Text from 'components/_new/typography/Text/Text'

import Link from '../Link/Link'

import messages from './messages'


const SEOCategoryLinks: React.FunctionComponent = () => {
  const intl = useIntl()

  const { gender, pathname } = useConnect({
    gender: 'view.seoPage.gender',
    pathname: 'view.seoPage.pathname',
  })

  const { path, bestsellersTitle } = useMemo(() => {
    const categories = {
      '/perfumes': messages.perfumes,
      '/colognes': messages.colognes,
      '/fragrance': messages.fragrance,
    }

    const category = intl.formatMessage(categories[pathname] || { ...messages.category, values: { gender } })
    const bestsellersTitle = { ...messages.bestSelling, values: { category } }

    return {
      path: category,
      bestsellersTitle,
    }
  }, [ gender, pathname ])

  const links = useMemo(() => [
    {
      to: `/best-selling-${path}`,
      title: bestsellersTitle,
    },
    {
      to: `/new-arrivals-${path}`,
      title: messages.newArrivals,
    },
  ], [ path, bestsellersTitle ])

  return (
    <Fragment>
      {
        links.map(({ title, to }, index) => (
          <Link key={index} to={to}>
            <Text
              message={title}
              size="12-24"
              color="black"
              uppercase
              semibold
            />
          </Link>
        ))
      }
    </Fragment>
  )
}


export default SEOCategoryLinks
